/* eslint-disable react/no-multi-comp */

// Modules
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import find from 'lodash/find';
import get from 'lodash/get';
import map from 'lodash/map';

import { Table, SortableTH } from 'components/content-containers/tables';
import CheckableTR from 'components/content-containers/tables/checkable-tr';
import CompanyNickname from 'components/models/company/company-nickname';
import Person from 'services/data/person';
import PhoneNumber from 'services/data/phone-number';
import Tooltip from 'components/widgets/overlays/tooltip';
import replaceById from 'utils/replace-by-id';

function handleCheckableRow(event, item, list, update) {
  if (item.checkboxDisabled) return;

  const clicked = { ...item, checked: !item.checked, lastChecked: !item.checked };
  const updates = [clicked];

  const lastChecked = _.find(list, 'lastChecked');
  if (lastChecked && lastChecked.id !== clicked.id) updates.push({ ...lastChecked, lastChecked: false });

  if (event.shiftKey && clicked.checked && lastChecked) {
    const start = _.indexOf(list, lastChecked);
    const end = _.indexOf(list, item);
    
    _.forEach(_.slice(list, start, end), inRange => {
      updates.push({ ...inRange, checked: true, lastChecked: false });
    });
  }

  update(replaceById(updates, list));
}

// Component
class PeopleTable extends React.Component {
  constructor() {
    super();

    this.handleCheck = (event, item) => handleCheckableRow(event, item, this.props.people, this.props.update);
  }

  render() {
    const { checkable = true, people } = this.props;
    const RowEl = checkable ? CheckableTR : 'tr';

    return (
      <Table>
        <thead>
          <tr>
            { checkable && <th className="col-checkbox"></th> }
            <SortableTH sortField="firstName">Name</SortableTH>
            <SortableTH sortField="company.name">Company</SortableTH>
            <th>Primary Email</th>
            <th>Work Number</th>
            <th>Mobile Number</th>
            <th>Tags</th>
          </tr>
        </thead>
        <tbody>
          {map(people, (person) =>
            <PeopleRow key={person.id} person={person} RowEl={RowEl} checkable={checkable} handleCheck={this.handleCheck} />
          )}
        </tbody>
      </Table>
    );
  }
}

// Prop types
PeopleTable.propTypes = {
  people: PropTypes.array,
  update: PropTypes.func,
  checkable: PropTypes.bool
};

class PeopleRow extends React.Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.person !== this.props.person;
  }

  render() {
    const { person, RowEl, checkable, handleCheck } = this.props;
    const email = get(person, 'primaryEmail.email');
    const mobilePhone = get(find(person.phoneNumbers, { type: 'Mobile' }), 'number');
    const workPhone = get(find(person.phoneNumbers, { type: 'Work' }), 'number');
    const disabled = person.status === 'Disabled';
    const archived = person.status === 'Archived';
    const rowOptions = { item: person, handleCheck };

    return (
      <RowEl {...(checkable ? rowOptions : {})} className={_.kebabCase(`status-${person.status}`)}>
        <td>
          <Link to={`/people/${person.id}`}>
            { disabled && '[Disabled] ' }
            { archived && '[Archived] ' }
            {Person.fullName(person)}
          </Link>
        </td>
        <td><CompanyNickname company={person.company} /></td>
        <td>
          { email &&
            <a href={`mailto:${email}`}>{email}</a>
          }
        </td>
        <td>
          { workPhone &&
            <a href={`tel:${workPhone}`}>{PhoneNumber.format(workPhone)}</a>
          }
        </td>
        <td>
          { mobilePhone &&
            <a href={`tel:${mobilePhone}`}>{PhoneNumber.format(mobilePhone)}</a>
          }
        </td>
        <td className="tag-cell">
          { _.map(person.tags, (tag, index) =>
            <Tooltip key={index} className="tag" elementType="span" title={tag}>
              { _.size(tag) > 2 && _(tag).words().map(_.head).join('') }
              { _.size(tag) <= 2 && tag }
            </Tooltip>
          ) }
        </td>
      </RowEl>
    );
  }
}

export default PeopleTable;



// WEBPACK FOOTER //
// ./app/components/models/person/people-table.js